import React, { useEffect, useState } from "react";
import "./Client.css";
import Banner from "../assets/images/banner.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const data = [
  {
    content:
      "<p>Thanh Flower áp dụng công nghệ 4.0 vào quy trình xử lý<br />Giúp rút ngắn thời gian hoàn thành đơn hàng chỉ còn <strong>MỘT NỬA</strong> so với truyền thống </p>",
  },
  {
    content:
      "<p>Toàn bộ mẫu hoa của Thanh Flower<br />Đều được thiết kế bởi những <strong>Floriost</strong> chuyên nghiệp</p>",
  },
  {
    content: "<p>Giao hoa <strong>SIÊU TỐC 45 PHÚT</strong></p>",
  },
  {
    content: "<p>Cam kết giao hoa đúng giờ</p>",
  },
];

const BannerSlider = () => {
  const [bannerData, setBannerData] = useState([]);

  useEffect(() => {
    getBanner();
  }, []);

  const getBanner = () => {
    axios
      .get(`/api/v1/images/get-banner`)
      .then((res) => {
        setBannerData(res.data);
      })
      .catch((err) => console.log(err));
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
  };

  const settingsBanner = {
    dots: false,
    infinite: bannerData.length > 1 ? true : false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
  };

  return (
    <div className="banner-slider-container mt-3">
      <div className="banner-container">
        <Slider {...settingsBanner}>
          {bannerData.map((item, idx) => (
            <img src={item.path} alt="" key={idx} />
          ))}
        </Slider>
      </div>
      <div className="slider-container mt-3">
        <Slider {...settings}>
          {data.map((item, idx) => (
            <div
              className="slider-item"
              key={idx}
              dangerouslySetInnerHTML={{ __html: item.content }}
            ></div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default BannerSlider;
